var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"desktop-view"},[_c('DesktopPage')],1),_c('div',{staticClass:"mobile-view"},[_c('MobilePage')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }